import type { MonitoringTag } from 'constants/monitoring';

type SeverityLevel = 'error' | 'debug' | 'log' | 'fatal' | 'warning' | 'info';

type Tags = {
  [K in MonitoringTag]?: boolean;
};

interface EnhancedErrorOptions {
  cause?: unknown;
  level?: SeverityLevel;
  tags?: Tags;
  message?: string;
}

export class EnhancedError extends Error {
  level: SeverityLevel;

  tags: Tags;

  constructor(options: EnhancedErrorOptions) {
    const message = options.cause instanceof Error ? options.cause.message : 'Something went wrong';

    super(options.message || message, { cause: options.cause });

    this.level = options.level || 'error';
    this.tags = options.tags || {};
  }
}
